import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customerperformance',
  templateUrl: './customerperformance.component.html',
  styleUrls: ['./customerperformance.component.css']
})
export class CustomerperformanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
